// extracted by mini-css-extract-plugin
module.exports = {"Profile":"Styles_Profile__3QfHV","Form":"Styles_Form__3YJDL","Buttons":"Styles_Buttons__2bfrC","red":"Styles_red__kWk9N"};